import { render, staticRenderFns } from "./coursewareList.vue?vue&type=template&id=3dd81c6e&scoped=true&"
import script from "./coursewareList.vue?vue&type=script&lang=js&"
export * from "./coursewareList.vue?vue&type=script&lang=js&"
import style0 from "./coursewareList.vue?vue&type=style&index=0&id=3dd81c6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd81c6e",
  null
  
)

export default component.exports